import React, { useState, useEffect } from 'react';
import { motion, AnimatePresence, easeInOut, } from 'framer-motion';
import { Book, Users, Clock, Calendar, ArrowRight, Download, BookOpen, Star, ChevronLeft, ChevronRight, X } from 'lucide-react';
import ImagesDev from '../../api/images';
import { useSprings, animated, to as interpolate } from 'react-spring';
import { useGesture } from 'react-use-gesture';
import { EventsHighlights } from '../../components/EventsHighlights';
import { StackedCarousel } from '../../components/react-card-stack-carousel-main/src/StackedCarousel';
import useFetchYouTubeResources, { justFetchYouTubeResources, extractVideoId, parseISO8601Duration, fetchYouTubeResources, truncateHTML } from '../../api/useFetchYouTubeResources';
import { audioLinks, bibleStudy_Links } from '../../api/youtubeLinks';
const API_KEY = process.env.REACT_APP_YOUTUBE_API_KEY;
const API_URL = 'https://tsoministries.com/wp-json/wp/v2/youtube_resource';


function BibleStudy() {
  const [activeTab, setActiveTab] = useState('upcoming');
  const [activeTestimony, setActiveTestimony] = useState(0);
  const [upcomingStudies, setUpcomingStudies] = useState([]);

  const testimonies = [
    {
      image: ImagesDev.gallery.lifeInTheSpirit[1]
    },
    {
      image: ImagesDev.gallery.lifeInTheSpirit[1]
    },
    {
      image: ImagesDev.gallery.lifeInTheSpirit[1]
    }
  ];
  const studyMaterials = [
    {
      title: "POP MY CHERRY NOW",
      format: "PDF",
      size: "2.5 MB",
      description: "This gives me such great joy to do. I remember going through vaginismus wondering if God knew I was married or maybe there was a certain heavenly form I needed to fill to open up the entry. I was confused. I never saw this coming.",
      image: "https://files.selar.co/product-images/2023/products/titoluwa-sam-oladapo1/pop-my-cherry-now-selar.co-650d1e3b5d3ef.jpeg",
      url: "https://selar.com/15293h"
    },
    {
      title: "FOCUS",
      format: "PDF",
      size: "2.5 MB",
      description: "What if becoming all God intended you to be starts with one simple act: looking? In FOCUS, you’ll discover the transformative power of spiritual sight—how the direction of your gaze determines the direction of your life. Rooted in biblical truth and filled with",
      image: "https://tsoministries.com/wp-content/uploads/2025/06/@titothewriter-focus.jpeg",
      url: "https://www.faveshq.com/home/product/682703ba39b95b01ce59612b/67ab79feda1bcd9b1ae76ee5/titothewriter"
    },
    // {
    //   title: "Bible Study Methods Workbook",
    //   format: "PDF",
    //   size: "1.8 MB",
    //   description: "Learn effective methods for studying the Bible",
    //   image: "https://images.unsplash.com/photo-1519677584237-752f8853252e"
    // },
    // {
    //   title: "Scripture Memory Cards",
    //   format: "PDF",
    //   size: "1.2 MB",
    //   description: "Cards to help you memorize key Bible verses",
    //   image: "https://images.unsplash.com/photo-1504052434569-70ad5836ab65"
    // }
  ];
  const achievements = [
    { number: "1,000+", label: "Students Enrolled" },
    { number: "50+", label: "Study Programs" },
    { number: "95%", label: "Completion Rate" },
    { number: "24/7", label: "Support Available" }
  ];

  useEffect(() => {
    const interval = setInterval(() => {
      setActiveTestimony((prev) => (prev + 1) % testimonies.length);
    }, 5000);
    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    fetchYouTubeResources('bible_study').then(setUpcomingStudies);
  }, []);



  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      className="min-h-screen bg-gradient-to-b from-gray-600 to-gray-600 text-white pt-0"
    >
      {/* Hero Section */}
      <div className="relative mb-4 md:mb-16 py-32">
        <motion.div
          initial={{ scale: 1.2 }}
          animate={{ scale: 1 }}
          transition={{ duration: 1.5 }}
          className="absolute inset-0"
        >
          <img
            src={ImagesDev.TSO_BG}
            alt="Bible Study"
            className="w-full h-full object-cover object-center"
          />
          <div className="absolute inset-0 bg-gradient-to-r from-black/80 via-black/60 to-black/80" />
        </motion.div>

        <div className="relative container mx-auto px-4 h-full flex flex-col justify-center">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.5 }}
            className="max-w-3xl"
          >
            <p className='font-bold ml-2'>BST - Bible Study</p>
            <h1 className="text-5xl md:text-7xl font-bold mb-6">
              The Scripture with
              <span className="text-transparent bg-clip-text bg-gradient-to-r from-amber-400 to-amber-600">
                {" "}The Lens of Christ
              </span>
            </h1>
            <p className="text-xl md:text-2xl text-gray-300 mb-8">
              Dive deep into God's Word and discover life-changing truths through our comprehensive Bible study programs
            </p>
            <div className="flex flex-wrap gap-4">
              <motion.button
                whileHover={{ scale: 1.05 }}
                whileTap={{ scale: 0.95 }}
                onClick={() => window.open("https://www.youtube.com/@titothewriter/streams")}
                className="px-8 py-3 bg-amber-600 text-white rounded-full hover:bg-amber-700 transition-colors"
              >
                Start Learning
              </motion.button>
              <motion.button
                whileHover={{ scale: 1.05 }}
                whileTap={{ scale: 0.95 }}
                onClick={() => window.location.href = "/ministries/bible-study#programs"}
                className="px-8 py-3 bg-white/10 text-white rounded-full hover:bg-white/20 transition-colors"
              >
                View Programs
              </motion.button>
            </div>
          </motion.div>
        </div>

        {/* Floating Achievement Cards */}
        <div className="relative left-0 right-0 transform translate-y-1/3 md:translate-y-1/2">
          <div className="container mx-auto px-4">
            <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
              {achievements.map((achievement, index) => (
                <motion.div
                  key={index}
                  initial={{ opacity: 0, y: 20 }}
                  animate={{ opacity: 1, y: 0 }}
                  transition={{ delay: 0.8 + index * 0.1 }}
                  className="bg-white/10 backdrop-blur-lg rounded-xl p-6 border border-white/20"
                >
                  <h3 className="text-3xl font-bold text-amber-400 mb-2">{achievement.number}</h3>
                  <p className="text-gray-300">{achievement.label}</p>
                </motion.div>
              ))}
            </div>
          </div>
        </div>
      </div>

      {/* Features Section */}
      <div className="container mx-auto px-4">
        <div className="grid grid-cols-1 md:grid-cols-[30%_70%] gap-8 mb-10 mt-0 md:px-20 md:pr-32">
          <BST_Testimonies />

          <div>
            <div className="grid grid-cols-2 gap-4 md:pt-8">
              <motion.div
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ delay: 0.2 }}
                className="bg-gradient-to-br from-purple-600/20 to-purple-900/20 p-8 rounded-2xl backdrop-blur-sm border border-purple-500/20"
              >
                <Users className="w-12 h-12 text-purple-400 mb-6" />
                <h3 className="text-md md:text-2xl font-bold mb-4">Group Discussion</h3>
                <p className="text-xs md:text-lg  text-gray-300">
                  Interactive sessions that foster deeper understanding through shared insights
                </p>
              </motion.div>

              <motion.div
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ delay: 0.4 }}
                className="bg-gradient-to-br from-blue-600/20 to-blue-900/20 p-8 rounded-2xl backdrop-blur-sm border border-blue-500/20"
              >
                <Star className="w-12 h-12 text-blue-400 mb-6" />
                <h3 className="text-md md:text-2xl  font-bold mb-4">Expert Guidance</h3>
                <p className="text-xs md:text-lg  text-gray-300">
                  Learn from experienced teachers who bring the Scripture to life
                </p>
              </motion.div>
            </div>
            <div>
              <p className="text-md md:text-2xl text-gray-300 p-3">
                Dive deep into God’s Word, let your soul be enticed,
                Unveil sacred truth through the lens of Christ.
                In each page, find grace, in each line, see light,
                Our Bible studies guide you from darkness to might.
                With hearts aligned and spirits sufficed,
                Come journey the Scripture with the lens of Christ.
              </p>
            </div>
          </div>
        </div>
      </div>

      {/* Programs Section */}
      <div id='programs' className="w-full bg-black">
        <div className="container mb-24 mx-auto px-4 py-10">
          <div className="flex flex-col md:flex-row items-center justify-between mb-12">
            <div>
              <h2 className="text-4xl font-bold mb-4">Our Programs</h2>
              <p className="text-xl text-gray-400">Choose the perfect study program for your spiritual growth</p>
            </div>
            <div className="flex gap-2 p-1 bg-white/5 rounded-full backdrop-blur-sm mt-4 md:mt-0">
              <button
                onClick={() => setActiveTab('upcoming')}
                className={`px-6 py-2 rounded-full transition-colors ${activeTab === 'upcoming'
                  ? 'bg-amber-600 text-white'
                  : 'text-gray-400 hover:text-white'
                  }`}
              >
                Ongoing
              </button>
              <button
                onClick={() => setActiveTab('materials')}
                className={`px-6 py-2 rounded-full transition-colors ${activeTab === 'materials'
                  ? 'bg-amber-600 text-white'
                  : 'text-gray-400 hover:text-white'
                  }`}
              >
                Materials
              </button>
            </div>
          </div>

          <AnimatePresence mode="wait">
            {activeTab === 'upcoming' ? (
              <motion.div
                key="upcoming"
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                exit={{ opacity: 0, y: -20 }}
                className="grid md:grid-cols-3 gap-8"
              >
                {upcomingStudies.map((study, index) => (
                  <motion.div
                    key={index}
                    initial={{ opacity: 0, y: 20 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ delay: index * 0.1 }}
                    className="group relative overflow-hidden rounded-xl bg-white/5 backdrop-blur-sm border border-white/10"
                  >
                    <div className="aspect-video relative overflow-hidden">
                      <img
                        src={study.thumbnail}
                        alt={study.title}
                        className="absolute inset-0 w-full h-full object-cover transition-transform duration-500 group-hover:scale-110"
                      />
                      <div className="absolute top-4 right-4">
                        <span className="px-3 py-1 bg-amber-600/80 text-white text-sm rounded-full backdrop-blur-sm">
                          live
                        </span>
                      </div>
                    </div>

                    <div className="p-6">
                      <div
                        className="text-xl font-bold mb-2"
                        dangerouslySetInnerHTML={{ __html: truncateHTML(study?.title, 50) }}
                      />
                      <div
                        className="text-gray-400 mb-4" 
                        dangerouslySetInnerHTML={{
                          __html: truncateHTML(study?.description, 50),
                        }}
                      />

                      {/* <p className="text-gray-400 mb-4">{JSON.stringify(study.description?.slice(0, 50))}{study.description?.length >= 50 ? "..." : ""}</p> */}
                      <div className="space-y-2 text-sm text-gray-300">
                        <div className="flex items-center gap-2">
                          <Calendar className="w-4 h-4" />
                          <span>Starts: {study?.publishedAt}</span>
                        </div>
                        <div className="flex items-center gap-2">
                          <Clock className="w-4 h-4" />
                          <span>Duration: {study?.duration}</span>
                        </div>
                      </div>
                      <motion.button
                        whileHover={{ x: 5 }}
                        onClick={() => window.open(study.link)}
                        className="flex items-center gap-2 text-amber-400 hover:text-amber-300 transition-colors mt-4"
                      >
                        Follow Class
                        <ArrowRight className="w-4 h-4" />
                      </motion.button>
                    </div>
                  </motion.div>
                ))}
              </motion.div>
            ) : (
              <motion.div
                key="materials"
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                exit={{ opacity: 0, y: -20 }}
                className="grid md:grid-cols-3 gap-8"
              >
                {studyMaterials.map((material, index) => (
                  <motion.div
                    key={index}
                    initial={{ opacity: 0, y: 20 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ delay: index * 0.1 }}
                    className="group relative overflow-hidden rounded-xl bg-white/5 backdrop-blur-sm border border-white/10"
                  >
                    <div className="aspect-video relative overflow-hidden">
                      <img
                        src={material.image}
                        alt={material.title}
                        className="absolute inset-0 w-full h-full object-cover transition-transform duration-500 group-hover:scale-110"
                      />
                      <div className="absolute inset-0 bg-gradient-to-t from-gray-900 to-transparent" />
                      <div className="absolute top-4 right-4">
                        <span className="px-3 py-1 bg-white/20 text-white text-sm rounded-full backdrop-blur-sm">
                          {material.format}
                        </span>
                      </div>
                    </div>

                    <div className="p-6">
                      <h3 className="text-xl font-bold mb-2">{material.title}</h3>
                      <p className="text-gray-400 mb-4">{material.description}</p>
                      <div className="flex items-center justify-between">
                        <span className="text-sm text-gray-500">{material.size}</span>
                        <motion.button
                          whileHover={{ scale: 1.1 }}
                          whileTap={{ scale: 0.9 }}
                          className="p-2 bg-white/10 rounded-full hover:bg-white/20 transition-colors"
                          onClick={() => window.open(material.url)}
                        >
                          <Download className="w-5 h-5" />
                        </motion.button>
                      </div>
                    </div>
                  </motion.div>
                ))}
              </motion.div>
            )}
          </AnimatePresence>
        </div>
      </div>

      {/* Event Highlights */}
      <div className="container mx-auto px-4 pb-2">
        <EventsHighlights parent="bible_study" />
      </div>

      {/* Call to Action */}
      <div className="container mx-auto px-4 pb-12">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="relative overflow-hidden rounded-2xl"
        >
          <div className="absolute inset-0">
            <img
              src="https://images.unsplash.com/photo-1501281668745-f7f57925c3b4"
              alt="Background"
              className="w-full h-full object-cover"
            />
            <div className="absolute inset-0 bg-gradient-to-r from-black/90 to-black/70 backdrop-blur-sm" />
          </div>

          <div className="relative p-12 md:p-24 text-center">
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
            >
              <h2 className="text-4xl md:text-5xl font-bold mb-6">
                Ready to Begin Your Journey?
              </h2>
              <p className="text-xl text-gray-300 mb-8 max-w-2xl mx-auto">
                Join our Bible study community and experience transformation through the power of God's Word
              </p>
              <motion.button
                whileHover={{ scale: 1.05 }}
                whileTap={{ scale: 0.95 }}
                onClick={() => { window.location.href = "/register" }}
                className="px-8 py-3 bg-gradient-to-r from-amber-500 to-amber-600 text-white rounded-full hover:from-amber-600 hover:to-amber-700 transition-all duration-300 shadow-lg"
              >
                Register Now
              </motion.button>
            </motion.div>
          </div>
        </motion.div>
      </div>
    </motion.div>
  );
}

export default BibleStudy










const cards = ImagesDev.bstTestimonies;



function BST_Testimonies() {
  const [activeIndex, setActiveIndex] = useState(0);
  const [modalImage, setModalImage] = useState(null);


  const handleNext = () => {
    if (activeIndex < ImagesDev.bstTestimonies.length - 1) {
      setActiveIndex(activeIndex + 1);
    }
  };

  const handleBack = () => {
    if (activeIndex > 0) {
      setActiveIndex(activeIndex - 1);
    }
  };

  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true }}
      transition={{ delay: 0.2 }}
      className="relative h-full w-full flex items-center"
    >
      <StackedCarousel
        pagination
        loop
        height={530}
        startIndex={0}
        className="h-80"
      >
        {ImagesDev.bstTestimonies.map((item) => (
          <div
            key={item.img}
            onClick={() => setModalImage(item.img)}
            className="overflow-hidden px-0 h-[460px] cursor-pointer"
          >
            <img
              src={item.img}
              alt="Bible Study"
              className="w-full h-full object-cover object-center shadow-md rounded-2xl "
            />
          </div>
        ))}
      </StackedCarousel>

      <AnimatePresence>
        {modalImage && (
          <motion.div
            className="fixed inset-0 z-50 bg-black/90 backdrop-blur flex items-center justify-center"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            onClick={() => setModalImage(null)}
          >
            <div className="relative max-w-3xl w-full px-4">
              <img src={modalImage} alt="Zoomed Testimony" className="rounded-xl w-full h-auto max-h-[80vh] object-contain" />
              <button
                className="absolute top-4 right-4 bg-white/10 p-2 rounded-full hover:bg-white/20"
                onClick={(e) => {
                  e.stopPropagation();
                  setModalImage(null);
                }}
              >
                <X className="w-6 h-6 text-white" />
              </button>
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </motion.div>
  );
}


function BST_Testimonies_quiteCool() {
  const [activeIndex, setActiveIndex] = useState(0);
  const calcStyles = (i, activeIndex) => {
    const diff = i - activeIndex;
    const scale = 1 - Math.min(Math.abs(diff) * 0.1, 0.5);
    const rotate = diff * 5;
    const opacity = diff > 4 || diff < -4 ? 0 : 1 - Math.abs(diff) * 0.15;
    const zIndex = 100 - Math.abs(diff);

    return {
      x: diff * 20,
      y: diff * 10,
      scale,
      rotate,
      opacity,
      zIndex
    };
  };

  const [springs, api] = useSprings(cards.length, i => ({
    ...calcStyles(i, activeIndex),
    config: { mass: 1, tension: 300, friction: 40 },
  }));

  const handleNext = () => {
    if (activeIndex < cards.length - 1) {
      setActiveIndex(prev => prev + 1);
      api.start(i => calcStyles(i, activeIndex + 1));
    }
  };

  const handlePrev = () => {
    if (activeIndex > 0) {
      setActiveIndex(prev => prev - 1);
      api.start(i => calcStyles(i, activeIndex - 1));
    }
  };

  return (
    <div className="relative w-full flex justify-center items-center py-10">
      <button
        onClick={handlePrev}
        className="absolute left-4 z-50 p-2 bg-white rounded-full shadow-md hover:bg-gray-100"
      >
        <ChevronLeft />
      </button>

      <div className="relative w-[300px] h-[400px]">
        {springs.map(({ x, y, scale, rotate, opacity, zIndex }, i) => (
          <animated.div
            key={i}
            className="absolute w-full h-full bg-cover bg-center rounded-xl shadow-lg"
            style={{
              backgroundImage: `url(${cards[i].img})`,
              transform: interpolate([x, y, scale, rotate], (x, y, s, r) =>
                `translate3d(${x}px,${y}px,0) scale(${s}) rotate(${r}deg)`
              ),
              opacity,
              zIndex,
            }}
          />
        ))}
      </div>

      <div className='absolute left-4 z-50'>
        <button
          onClick={handleNext}
          className="absolute right-4 z-50 p-2 bg-white rounded-full shadow-md hover:bg-gray-100"
          style={{ zIndex: 30 }}
        >
          <ChevronRight />
        </button>
      </div>
    </div>
  );
}

function BST_Testimonies_HomePageSliderAnimation() {
  const [activeIndex, setActiveIndex] = useState(0);
  const [modalImage, setModalImage] = useState(null);
  const [index, setIndex] = useState(0);
  const [direction, setDirection] = useState(1);

  const handleNext = () => {
    if (activeIndex < ImagesDev.bstTestimonies.length - 1) {
      setActiveIndex(activeIndex + 1);
    }
  };

  const handleBack = () => {
    if (activeIndex > 0) {
      setActiveIndex(activeIndex - 1);
    }
  };

  const nextSlide = () => {
    setDirection(1);
    setIndex((prev) => (prev + 1) % slides.length);
  };

  const prevSlide = () => {
    setDirection(-1);
    setIndex((prev) =>
      prev === 0 ? slides.length - 1 : prev - 1
    );
  };

  const slides_ = [
    {
      id: 1,
      title: 'T.S.O Ministries',
      subTitle: "Till every eye sees Jesus",
      subTitle2: "",
      // subTitle2: "Proclaiming Christ to all nations",
      image: ImagesDev.heroImagesDesk[1],
      bgClass: ""
    },
    {
      id: 2,
      title: 'Redeeming Love',
      subTitle: "Saved by His sacrifice",
      subTitle2: "Accepted into the Beloved",
      image: ImagesDev.heroImages[5],
      bgClass: "object-[center_35%]"
    },
    {
      id: 3,
      title: 'Living Word',
      subTitle: "Every promise fulfilled",
      subTitle2: "As Christ Is Revealed",
      // subTitle2: "The Gospel That Transforms",
      image: ImagesDev.heroImagesDesk[5],
      bgClass: ""
    },
    {
      id: 4,
      title: 'Eternal Light',
      subTitle: "Shining in the darkness",
      subTitle2: "I carry That Light!",
      image: ImagesDev.heroImages[10],
      bgClass: ""
    }
  ];
  const slides = ImagesDev.bstTestimonies

  useEffect(() => {
    const interval = setInterval(() => {
      nextSlide();
    }, 6000);

    return () => clearInterval(interval); // Cleanup on unmount
  }, [index]);

  const imageVariants_ = {
    initial: (direction) => ({
      opacity: 0,
      borderStartEndRadius: 50, borderStartStartRadius: 50,
      y: direction > 0 ? "100%" : "-100%", // Start off-screen
    }),
    animate: {
      y: "0%",
      opacity: 1,
      borderStartEndRadius: 0, borderStartStartRadius: 0,
      transition: { duration: 1.7, ease: easeInOut, delay: 0.1 },
    },
    exit: (direction) => ({
      y: direction > 0 ? "-100%" : "100%", // Move out of screen
      opacity: 0, borderStartEndRadius: 50, borderStartStartRadius: 50,
      transition: { duration: 1.3, ease: easeInOut, delay: 0.5 },
    }),
  };

  const imageVariants = {
    initial: (direction) => ({
      opacity: 0.1,
      y: direction > 0 ? "10%" : "10%", // Start off-screen
    }),
    animate: {
      y: "0%",
      opacity: 1,
      transition: { duration: 1.7, ease: easeInOut, delay: 0.1 },
    },
    exit: (direction) => ({
      y: direction > 0 ? "10%" : "10%", // Move out of screen
      opacity: 0.1,
      transition: { duration: 1.3, ease: easeInOut, delay: 0.5 },
    }),
  };

  const activeSlide = ImagesDev.bstTestimonies[activeIndex];

  return (
    <div className="relative h-full w-full flex items-center">
      <button
        onClick={prevSlide}
        className="absolute -left-6 top-1/2 transform -translate-y-1/2 z-10 p-2 rounded-full bg-white/10 hover:bg-white/20 backdrop-blur"
      >
        <ChevronLeft className="w-6 h-6 text-white" />
      </button>

      {/* <div className="relative h-[450px] w-full max-w-md mx-auto flex items-center justify-center">
        {ImagesDev.bstTestimonies.map((value, index) => {
          const diff = index - activeIndex;

          if (diff < 0 || diff >= MAX_VISIBLE) return null;

          const rotate = diff === 0 ? 'rotate-0' : diff % 2 === 0 ? '-rotate-3' : 'rotate-3';
          const rotate_ = diff === 0 ? '0deg' : diff % 2 === 0 ? '20deg' : '20deg';
          const zIndex = MAX_VISIBLE - diff;
          const opacity = 1 - diff * 0.2;

          return (
            <motion.div
              key={index}
              initial={{ opacity: 0, scale: 0.95, y: 20, rotate: rotate_ }}
              animate={{ opacity, scale: diff === 0 ? 1 : 0.95, y: 0, rotate: rotate_ }}
              exit={{ opacity: 0, scale: 0.9, y: -20, rotate: rotate_, }}
              transition={{ duration: 0.6 }}
              className={`absolute top-0 left-0 w-full h-full p-4 cursor-pointer transition-all duration-600`}
              style={{ zIndex }}
              onClick={() => diff === 0 && setModalImage(value.img)}
            >
              <div className="bg-gradient-to-br from-amber-600/20 to-amber-900/20 p-6 rounded-2xl backdrop-blur-sm border border-amber-500/20 h-full">
                <img
                  src={value.img}
                  alt="Bible Study"
                  className="w-full h-full object-cover object-center rounded-xl"
                />
              </div>
            </motion.div>
          );
        })}
      </div> */}

      <div className="relative h-[450px] w-full max-w-md mx-auto flex items-center justify-center">
        <AnimatePresence mode="popLayout" custom={direction}>
          <motion.div
            key={slides[index].img}
            variants={imageVariants}
            initial="initial"
            animate="animate"
            exit="exit"
            custom={direction}
            className={`absolute inset-0`}
            // style={{ zIndex }}
            onClick={() => setModalImage(activeSlide.img)}
          >
            <div className="bg-gradient-to-br from-amber-600/20 to-amber-900/20 p-6 rounded-2xl backdrop-blur-sm border border-amber-500/20 h-full">
              <img
                src={slides[index].img}
                alt="Bible Study"
                className="w-full h-full object-cover object-center rounded-xl"
              />
            </div>
          </motion.div>
        </AnimatePresence>
      </div>


      <button
        onClick={nextSlide}
        className="absolute -right-6 top-1/2 transform -translate-y-1/2 z-10 p-2 rounded-full bg-white/10 hover:bg-white/20 backdrop-blur"
      >
        <ChevronRight className="w-6 h-6 text-white" />
      </button>

      <AnimatePresence>
        {modalImage && (
          <motion.div
            className="fixed inset-0 z-50 bg-black/90 backdrop-blur flex items-center justify-center"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            onClick={() => setModalImage(null)}
          >
            <div className="relative max-w-3xl w-full px-4">
              <img src={modalImage} alt="Zoomed Testimony" className="rounded-xl w-full h-auto max-h-[80vh] object-contain" />
              <button
                className="absolute top-4 right-4 bg-white/10 p-2 rounded-full hover:bg-white/20"
                onClick={(e) => {
                  e.stopPropagation();
                  setModalImage(null);
                }}
              >
                <X className="w-6 h-6 text-white" />
              </button>
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
}
